import {NgModule} from '@angular/core';
import {ProductComponent} from './product.component';
import {CommonModule} from '@angular/common';
import {ProductRoutingModule} from './product-routing.module';

import {MatIcon, MatIconModule} from '@angular/material/icon';
import {MatSelectModule} from '@angular/material/select';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatOptionModule} from '@angular/material/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {HttpClientModule} from '@angular/common/http';
import {MatButtonModule} from '@angular/material/button';
import {MatDialogModule} from '@angular/material/dialog';
import {DetailsProductComponent} from './details-product/details-product.component';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {ProductFilterDialogComponent} from './product-filter-dialog/product-filter-dialog.component';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MatRadioModule} from '@angular/material/radio';
import {MatButtonToggleModule} from '@angular/material/button-toggle';
import { ImgLazyBlurDirective } from "../directives/img-lazy-blur.directive";

@NgModule({
    imports: [CommonModule, ProductRoutingModule,
    MatButtonModule,
    MatIconModule,
    MatSelectModule,
    MatFormFieldModule,
    MatOptionModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule, MatIcon,
    MatCheckboxModule,
    MatDialogModule,
    MatProgressSpinnerModule,
    MatRadioModule,
    MatButtonToggleModule, ImgLazyBlurDirective, ProductComponent, DetailsProductComponent, ProductFilterDialogComponent]
})
export class ProductModule {

}
